import styled from 'styled-components';

export const GrantedPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  div:nth-child(2) {
    padding-bottom: 0;
  }

  .divButton {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 48px;

    @media (max-width: 650px) {
      > button {
        width: 100%;
      }
    }
  }

  .ownerContainer {
    display: flex;
    margin: 48px 0;
  }
`;

export const Name = styled.p`
  font-weight: bold;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: #333333;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const SubTitle = styled.p`
  letter-spacing: -0.2px;
  line-height: 20px;
  color: #333333;
  margin-top: 4px;
  margin-bottom: 0;
`;

export const SubContent = styled.p`
  font-family: 'Inter';
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: #333333;
  margin-top: 24px;
  margin-bottom: 0px;
`;

export const Img = styled.img`
  margin-top: 5px;
  margin-right: 10px;
  width: 24px;
  height: 24px;
`;

export const ProductContent = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 24px;
  img {
    margin-right: 8px;
  }
  p {
    margin: 0;
  }
`;
